import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { NgxsModule } from "@ngxs/store";
import { YearSelectionState } from "~app/inscription/store/year-selection/year-selection.state";
import { environment } from "~env";
import { NavigationModule } from "../core/navigation/navigation.module";
import {
  AccordionAnchorDirective,
  AccordionDirective,
  AccordionLinkDirective,
} from "./accordion";
import { CardHoverDirective } from "./card/card-hover.directive";
import { CardTileComponent } from "./card/card-tile/card-tile.component";
import { ConfidentialityAgreementComponent } from "./confidentiality-agreement/confidentiality-agreement.component";
import { ConfirmDialogComponent } from "./confirm-dialog/confirm-dialog.component";
import { ContactUsComponent } from "./contact-us/contact-us.component";
import { LoadingSpinnerComponent } from "./directives/loading-spinner.component";
import { OdqFileUploadModule } from "./file/file-upload/file-upload.module";
import { ResponsiveColsDirective } from "./grid/responsive-cols-directive ";
import { HelpTopicBadgeDirective } from "./help-topic/directives/help-topic-mat-badge.directive";
import { HelpTopicStoreModule } from "./help-topic/state/help-topic.module";
import { NumberOnlyDirective } from "./input/number-only.directive";
import { AppFooterComponent } from "./layouts/full/footer/footer.component";
import { FullComponent } from "./layouts/full/full.component";
import { AppHeaderComponent } from "./layouts/full/header/header.component";
import { AppSidebarComponent } from "./layouts/full/sidebar/sidebar.component";
import { MaintenanceModule } from "./maintenance/maintenance.module";
import { MaterialModule } from "./material.module";
import { MenuItemDirective } from "./menu-items/menu-item.directive";
import { MenuItems } from "./menu-items/menu-items";
import { PageContentComponent } from "./page-content/page-content.component";
import { CurrencyCustomPipe } from "./pipes/currency.pipe";
import { FilterByDatePipe } from "./pipes/filter-by-date.pipe";
import { YesNoPipe } from "./pipes/yesNo.pipe";
import { SecurityModule } from "./security/security.module";
import { SessionTimeoutDialogComponent } from "./session-timeout-dialog/session-timeout-dialog.component";
import { SpinnerComponent } from "./spinner.component";
import { TabCardComponent } from "./tab-card/tab-card.component";
import { TabCardModule } from "./tab-card/tab-card.module";
import { TechnicalDifficultiesDialogComponent } from "./technical-difficulties-dialog/technical-difficulties-dialog.component";
import { TermsOfUseComponent } from "./terms-of-use/terms-of-use.component";
import { PrefixTextPipe } from "./text/prefix-text.pipe";

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    TranslateModule,
    SecurityModule,
    NavigationModule,
    OdqFileUploadModule,
    TabCardModule,
    MaintenanceModule,
    NgxsModule.forFeature([YearSelectionState]),
    HelpTopicStoreModule
  ],
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    FullComponent,
    AppHeaderComponent,
    AppSidebarComponent,
    AppFooterComponent,
    SpinnerComponent,
    NumberOnlyDirective,
    CardTileComponent,
    CardHoverDirective,
    ResponsiveColsDirective,
    CurrencyCustomPipe,
    PrefixTextPipe,
    FilterByDatePipe,
    YesNoPipe,
    ConfirmDialogComponent,
    TermsOfUseComponent,
    ConfidentialityAgreementComponent,
    ContactUsComponent,
    MenuItemDirective,
    LoadingSpinnerComponent,
    PageContentComponent,
    SessionTimeoutDialogComponent,
    TechnicalDifficultiesDialogComponent,
    HelpTopicBadgeDirective
  ],
  providers: [
    MenuItems,
    {
      provide: "canadaPostApiKey",
      useValue: environment.canadaPostApiKey,
    },
    {
      provide: "LanguageService",
      useExisting: TranslateService,
    },
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    MaterialModule,
    SpinnerComponent,
    NumberOnlyDirective,
    CardTileComponent,
    CardHoverDirective,
    ResponsiveColsDirective,
    OdqFileUploadModule,
    CurrencyCustomPipe,
    PrefixTextPipe,
    YesNoPipe,
    FilterByDatePipe,
    ConfirmDialogComponent,
    TermsOfUseComponent,
    ConfidentialityAgreementComponent,
    ContactUsComponent,
    TabCardComponent,
    MenuItemDirective,
    LoadingSpinnerComponent,
    PageContentComponent,
    HelpTopicBadgeDirective
  ],
})
export class SharedModule {}
